/**
 * EVIVA GAMBLE — Product grid interactions
 * Gender tabs, show more/less, header sync via eviva:gender event + URL param.
 */
(function () {
  const sections = document.querySelectorAll('[data-eviva-product-grid]');
  if (!sections.length) return;

  sections.forEach((section) => {
    initProductGrid(section);
  });

  function initProductGrid(section) {
    const visibleCount = parseInt(section.dataset.visibleCount || '6', 10);
    const tabs = section.querySelectorAll('[data-eviva-gender-tab]');
    const filterButtons = section.querySelectorAll('[data-eviva-product-filter]');
    const panels = section.querySelectorAll('[data-eviva-gender-panel]');
    const toggle = section.querySelector('[data-eviva-grid-toggle]');
    const toggleWrap = section.querySelector('[data-eviva-grid-toggle-wrap]');
    const labelMore = toggle?.dataset.labelMore || 'Zobacz wszystkie';
    const labelLess = toggle?.dataset.labelLess || 'Pokaż mniej';

    let activeGender = 'men';
    let activeFilter = 'all';
    let expanded = false;

    function getActivePanel() {
      return section.querySelector(`[data-eviva-gender-panel="${activeGender}"]`);
    }

    function getActiveItems() {
      const panel = getActivePanel();
      if (!panel) return [];
      return Array.from(panel.querySelectorAll('[data-eviva-product-item]'));
    }

    function updateVisibility() {
      const items = getActiveItems();

      const matchingItems = items.filter((item) => {
        return activeFilter === 'all' || item.dataset.productType === activeFilter;
      });

      const hasMore = matchingItems.length > visibleCount;

      let visibleIndex = 0;

      items.forEach((item) => {
        const matchesFilter =
          activeFilter === 'all' ||
          item.dataset.productType === activeFilter;

        let hidden = !matchesFilter;

        if (matchesFilter) {
          if (!expanded && visibleIndex >= visibleCount) {
            hidden = true;
          }

          visibleIndex += 1;
        }

        item.classList.toggle(
          'eviva-product-grid__item--hidden',
          hidden
        );

        item.toggleAttribute('hidden', hidden);
      });

      if (toggleWrap) {
        toggleWrap.hidden = !hasMore;
      }

      if (toggle) {
        toggle.textContent = expanded ? labelLess : labelMore;
        toggle.setAttribute(
          'aria-expanded',
          expanded ? 'true' : 'false'
        );
      }
    }

    function setGender(gender) {
      if (gender !== 'men' && gender !== 'women') return;

      activeGender = gender;
      expanded = false;

      tabs.forEach((tab) => {
        const isActive = tab.dataset.evivaGenderTab === gender;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.evivaGenderPanel === gender;
        panel.hidden = !isActive;
      });

      updateVisibility();
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        setGender(tab.dataset.evivaGenderTab);
      });
    });

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedFilter = button.dataset.evivaProductFilter;

        if (selectedFilter === activeFilter && selectedFilter !== 'all') {
          activeFilter = 'all';
        } else {
          activeFilter = selectedFilter;
        }

        expanded = false;

        filterButtons.forEach((filterButton) => {
          const isActive =
            filterButton.dataset.evivaProductFilter === activeFilter;

          filterButton.setAttribute(
            'aria-pressed',
            isActive ? 'true' : 'false'
          );
        });

        updateVisibility();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', () => {
        expanded = !expanded;
        updateVisibility();

        if (!expanded) {
          toggle.blur();

          requestAnimationFrame(() => {
            toggle.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          });
        }
      });
    }

    window.addEventListener('eviva:gender', (event) => {
      const gender = event.detail;
      setGender(gender);
      section.scrollIntoView({ behavior: 'smooth' });
    });

    const urlGender = new URLSearchParams(window.location.search).get('gender');
    if (urlGender === 'men' || urlGender === 'women') {
      setGender(urlGender);
      if (window.location.hash === '#products') {
        requestAnimationFrame(() => {
          section.scrollIntoView({ behavior: 'smooth' });
        });
      }
    } else {
      setGender('men');
    }
  }
})();
